import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'app/cache/queryClient';
import { AGENT_QUERY_KEYS } from 'app/modules/agents/queries/keys';
import { UpdateAgentCurrentStatusPayload } from 'app/modules/agents/requests';
import { ShortAgentResponse } from 'app/modules/agents/responses';
import { put } from 'app/shared/utils/fetchr';
import { useDispatch, useSelector } from 'react-redux';
import { selectAgent } from 'app/modules/session/selectors';
import { updateSessionAgentAvailabilitySuccess } from 'app/modules/session/actions';
import { sendErrorToast } from 'app/shared/toasts/actions';

export const useUpdateAgentCurrentStatus = () => {
  const dispatch = useDispatch();
  const sessionAgent = useSelector(selectAgent);

  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: number;
      payload: UpdateAgentCurrentStatusPayload;
    }) => put<ShortAgentResponse>(`/agents/${id}/current-status`, payload),
    onSuccess: (value, { id }) => {
      queryClient.invalidateQueries({
        queryKey: AGENT_QUERY_KEYS.getAgent(id),
      });
      queryClient.invalidateQueries({
        queryKey: AGENT_QUERY_KEYS.getAllAgents(),
      });

      if (id === sessionAgent.id) {
        dispatch(updateSessionAgentAvailabilitySuccess(value.current_status));
      }
    },
    onError: () => {
      dispatch(sendErrorToast('Failed to update agent current status.'));
    },
  });
};
